const GAP = 4;
const STYLES = [
  'font-weight',
  'font-style',
  'font-family',
  'line-height',
  'letter-spacing',
  'word-spacing',
  'text-transform',
  'white-space',
  'writing-mode',
  'direction'
] as const;

interface BinarySearchFontParams {
  minFontSize: number;
  maxFontSize: number;
  containerWidth: number;
  firstElement: HTMLElement;
  measurer: HTMLElement;
  secondElement?: HTMLElement | null;
  shouldResizeSecondElement?: boolean;
  secondElementFixedSize?: number;
}

const applyStyles = (element?: HTMLElement, styles?: CSSStyleDeclaration) => {
  if (!element || !styles) {
    return;
  }

  STYLES.forEach((style) => {
    element.style.setProperty(style, styles.getPropertyValue(style));
  });
};

export const binarySearchFontSize = ({
  minFontSize,
  maxFontSize,
  containerWidth,
  firstElement,
  secondElement,
  measurer,
  shouldResizeSecondElement,
  secondElementFixedSize
}: BinarySearchFontParams) => {
  let min = minFontSize;
  let max = maxFontSize;
  let bestSize = min;

  const firstElementStyles = getComputedStyle(firstElement);
  const secondElementStyles = secondElement
    ? getComputedStyle(secondElement)
    : undefined;

  while (min <= max) {
    const mid = (min + max) / 2;

    measurer.style.fontSize = `${mid}px`;
    measurer.textContent = firstElement.textContent;
    applyStyles(measurer, firstElementStyles);
    const newValueWidth = measurer.clientWidth;

    const secondElementFontSize =
      shouldResizeSecondElement && secondElement ? mid : secondElementFixedSize;
    measurer.style.fontSize = `${secondElementFontSize}px`;
    measurer.textContent = secondElement?.textContent ?? '';
    applyStyles(measurer, secondElementStyles);
    const secondElementWidth = measurer?.clientWidth;

    const newTotalWidth = secondElementWidth
      ? secondElementWidth + newValueWidth + GAP
      : newValueWidth;

    if (newTotalWidth > containerWidth) {
      max = mid - 1;
    } else {
      bestSize = Math.abs(mid - maxFontSize) < 1 ? maxFontSize : mid;
      min = mid + 1;
    }
  }

  firstElement.style.fontSize = `${bestSize}px`;

  if (secondElement && shouldResizeSecondElement) {
    secondElement.style.fontSize = `${bestSize}px`;
  }
};
